import {
  BaseUomFragment,
  FindOrderLinesByFilterQuery,
  FindOrderLinesByFilterQueryVariables,
  SimulationOrderLineFragment,
} from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import { getDataRows, getHeaderRow } from './export-converter.helper';
import { ColumnConfigBase, ExportConverter, ExportJobParams } from './types';

export type OrderLineByRuleRow = Omit<SimulationOrderLineFragment, 'baseUOm'> &
  BaseUomFragment;

export type OrderLineByRuleExportJobParams = ExportJobParams<
  FindOrderLinesByFilterQueryVariables,
  OrderLineByRuleConverterConfig
>;

export const orderLineByRuleExportJobParams: OrderLineByRuleExportJobParams = {
  converterId: 'ORDER_LINE_BY_RULE',
  query: null,
  config: null,
  variables: null,
  filename: 'order-lines-by-rule.csv',
};

export type OrderLineByRuleConverterConfig = {
  columnsConfig: ColumnConfigBase<OrderLineByRuleRow>[];
};

export const getOrderLineByRuleTableRows = (
  data: SimulationOrderLineFragment[],
  config?: OrderLineByRuleConverterConfig,
): OrderLineByRuleRow[] => {
  const getOrderLineByRuleRow = (row: SimulationOrderLineFragment) => {
    return {
      ..._.omit(row, 'baseUom'),
      ...row.baseUom,
    } as OrderLineByRuleRow;
  };
  return _.map(data, getOrderLineByRuleRow);
};

export const ORDER_LINE_BY_RULE_EXPORT_CONVERTER: ExportConverter<
  FindOrderLinesByFilterQuery,
  OrderLineByRuleConverterConfig
> = (input, config) => {
  const data = getOrderLineByRuleTableRows(
    input.findSimulationOrderLinesByFilter.content,
    config,
  );
  return [
    getHeaderRow(config.columnsConfig),
    getDataRows(data, config.columnsConfig),
  ];
};
